import api from 'ApiConfig';

const testService = {
  createCourse: async (data) => {
    return api.post('/admin/create-course', data);
  },
  getDailyTests: async () => {
    return api.post('/student/test-daily');
  },
  getRetestTests: async () => {
    return api.post('/student/retest');
  },
  getWeeklyTests: async () => {
    return api.post('/student/test-weekly');
  },
  getMonthlyTests: async () => {
    return api.post('/student/test-monthly');
  },
  getEndTests: async () => {
    return api.post('/student/test-end-test');
  },
  submitTestAnswers: async (payload) => {
    return api.post('/student/student-submit-test', payload);
  },
  viewAttendedTests: async () => {
    return api.post('/student/view-attended-test');
  },
  getTestStatus: async (testId) => {
    console.log(testId, 'testId');
    return api.post('/student/get-test-status', { testId });
  },
  startTest: async (testId) => {
    console.log(testId, 'testId');
    return api.post('/student/check-test-start', testId);
  },
  getStudentSubjects: async () => {
    return api.get('/student/subjects');
  },
  getStudentMockMarks: async (subject, date) => {
    return api.post('/student/mock-marks', { subject, date });
  },
  getMockTests: async () => {
    return api.post('/student/get-mock-test-link');
  },
  getMyExternalMockResults: async () => {
    return api.get('/student/my-external-mock-results');
  },
  getMyExternalPracticeResults: async () => {
    return api.get('/student/my-external-practice-results');
  },
};
export default testService;
